import React from "react";
import { Col } from "antd";
import { PriceBtn } from "../../StyledCmp";

const PriceBreakdown = ({
  title,
  carpetArea,
  price,
  isEven,
  handleModalVisibility,
}) => {
  return (
    <Col lg={20} className={`price_mobile_box ${isEven ? "even" : "odd"}`}>
      <h1>{title}</h1>
      <h3>{carpetArea} (Carpet Area)</h3>
      <p>{price}</p>
      <PriceBtn onClick={handleModalVisibility}>Price Breakup</PriceBtn>
    </Col>
  );
};

export default PriceBreakdown;
